var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"google-map",attrs:{"id":_vm.mapName,"loading":"lazy","referrerpolicy":"no-referrer-when-downgrade","src":_vm.mapsUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }